import { render, staticRenderFns } from "./ChatBotMcp.vue?vue&type=template&id=9ed6a858&"
import script from "./ChatBotMcp.vue?vue&type=script&lang=ts&"
export * from "./ChatBotMcp.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/components/chat-bot.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports